import { render, staticRenderFns } from "./showClueManage.vue?vue&type=template&id=359a050c&scoped=true"
import script from "./showClueManage.vue?vue&type=script&lang=js"
export * from "./showClueManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a050c",
  null
  
)

export default component.exports